import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import useNotifier from "@saleor/hooks/useNotifier";
import { DialogProps } from "@saleor/types";
import React, { useEffect } from "react";

const useStyles = makeStyles(
  {
    buttonConfirm: {
      backgroundColor: "#FFD15C !important",
      marginLeft: "8px"
    },
    buttonDisabled: {
      backgroundColor: "#A1A1A1 !important"
    },
    closeButton: {
      color: "#616161 !important",
      position: "absolute",
      right: "1px",
      top: "1px"
    },
    contentText: {
      fontSize: "17px",
      fontWeight: 400
    },
    deleteButton: {
      "& span": {
        color: "#ffffff !important"
      },
      backgroundColor: "#ec5d77 !important",
      border: "1px solid #ec5d77",
      color: "#ffffff !important",
      marginRight: "20px"
    },
    dialogContent: {
      display: "flex",
      flexDirection: "row",
      width: "100%"
    },
    footerActions: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      width: "100%"
    },
    textField: {
      marginTop: "20px",
      width: "100%"
    }
  },
  {
    name: "OrderAddRemarksDialog"
  }
);

interface OrderAddRemarksDialogProps extends DialogProps {
  onSubmitRemark: (remark) => void;
  oldRemarks: string;
}

const OrderAddRemarksDialog: React.FC<OrderAddRemarksDialogProps> = props => {
  const { onClose, open, onSubmitRemark, oldRemarks } = props;
  const classes = useStyles(props);
  const notify = useNotifier();

  const [remark, setRemark] = React.useState("");

  function isAplhanumeric(text) {
    return !/^[a-zA-Z0-9\s.,'-]*$/i.test(text);
  }

  function textRemarkHandler(e) {
    if (isAplhanumeric(e.target.value)) {
      notify({
        status: "error",
        text: `Character input should be alphanumeric characters only`
      });
      setRemark(remark);
    } else if (e.target.value.length > 250) {
      notify({
        status: "error",
        text: `Character input should be limited to 250 characters only`
      });
      setRemark(remark.slice(0, 250));
    } else {
      setRemark(e.target.value);
    }
  }

  useEffect(() => {
    setRemark(oldRemarks ? oldRemarks.slice(0, 250) : "");
  }, [oldRemarks]);

  return (
    <Dialog
      onClose={() => {
        onClose();
        setRemark("");
      }}
      open={open}
      maxWidth="xs"
      fullWidth
    >
      <>
        <DialogTitle>
          {!oldRemarks ? <span>Add Remark</span> : <span>Edit Remark</span>}
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <div className={classes.dialogContent}></div>
          <TextField
            id="remarkDialogTxt"
            className={classes.textField}
            multiline
            rows={6}
            value={remark}
            onChange={textRemarkHandler}
          ></TextField>
        </DialogContent>
        <DialogActions className={classes.footerActions}>
          <div>
            <Button
              id="delRemarkBtn"
              autoFocus
              onClick={() => {
                onClose();
                setRemark("");
                onSubmitRemark("");
              }}
              className={classes.deleteButton}
              disabled={remark === ""}
            >
              Delete Remark
            </Button>
            <Button
              id="updtRemakteBtn"
              autoFocus
              onClick={() => {
                onClose();
                setRemark("");
                onSubmitRemark(remark);
              }}
              color="primary"
              variant="contained"
              disabled={remark === ""}
            >
              Update Remark
            </Button>
          </div>
        </DialogActions>
      </>
    </Dialog>
  );
};

export default OrderAddRemarksDialog;
